import React from "react";
import Layout from "./layout";
import { Tab, Nav, Card, Form, Button, Row, Col } from "react-bootstrap";

const Submitfile: React.FC = () => {
  return (
    <Layout>
      <div data-aos="fade-up" data-aos-duration="1000">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-15">
                <h1 className="mb-0 text-xxl">
                  Submit a <span className="text-accent">File</span>
                </h1>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle rate_checker"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Rate Calculator <i className="mdi mdi-chevron-down"></i>
                  </button>
                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="#">
                      Polly Rate Checker
                    </a>
                    <div className="dropdown-item multidropdown">
                      Lender Price Rate Checker
                      <ul>
                        <li>
                          <a href="#">275 BPS</a>
                        </li>
                        <li>
                          <a href="#">200 BPS</a>
                        </li>
                        <li>
                          <a href="#">0 BPS</a>
                        </li>
                        <li>
                          <a href="#">Account</a>
                        </li>
                        <li>
                          <a href="#">
                            Powered by <strong>Lender Price</strong>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a href="javascript: void(0);">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="processor.html">Processors</a>
                  </li>
                  <li className="breadcrumb-item active">Submit A File</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <Tab.Container defaultActiveKey="confirm">
          <Row>
            {/* Sidebar Navigation */}
            <Col sm={2}>
              <Nav variant="pills" className="flex-column vr-tabs-panel">
                <Nav.Item>
                  <Nav.Link eventKey="confirm">
                    <span className="tabs-number">1</span> Confirm
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="terms">
                    <span className="tabs-number">2</span> Terms
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="LendFlow">
                    <span className="tabs-number">3</span> LendFlow
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="property">
                    <span className="tabs-number">4</span> Property
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link eventKey="borrower">
                    <span className="tabs-number">5</span> Borrower
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="loan">
                    <span className="tabs-number">6</span> Loan
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="info">
                    <span className="tabs-number">7</span> Title Company Contact
                    Info
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="processing">
                    <span className="tabs-number">8</span>Processing
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>

            {/* Tab Content */}
            <Col sm={10}>
              <div className="row h-100">
                <div className="col-sm-9">
                  <Tab.Content>
                    {/* Confirm Tab */}
                    <Tab.Pane eventKey="confirm">
                      <Card>
                        <Card.Body>
                          <div className="section-heading">
                            <h2>Personal Details</h2>
                          </div>
                          <div className="section-sub-heading d-flex justify-content-center mb-5">
                            <h3>Are You Submitting This File As</h3>
                          </div>
                          <div className="d-flex justify-content-center gap-3 mb-5">
                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                              <Form.Check
                                type="radio"
                                id="mortgageSupport"
                                name="submissionType"
                                label={<strong>Mortgage Support</strong>}
                                className="form-check-input"
                              />
                            </div>
                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                              <Form.Check
                                type="radio"
                                id="assistant"
                                name="submissionType"
                                label={
                                  <strong>Mortgage Support Assistant</strong>
                                }
                                className="form-check-input"
                              />
                            </div>
                          </div>
                          <div className="text-center">
                            <Button variant="primary" size="lg">
                              Next
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/* Terms Tab */}
                    <Tab.Pane eventKey="terms">
                      <Card>
                        <Card.Body>
                          <div className="section-heading">
                            <h2>Terms</h2>
                          </div>
                          <div className="terms-content-panel">
                            <h5>Pricing</h5>
                            <div className="pricing-block">
                              <div className="pricing-block-left">
                                <p>
                                  Non-Credit Qualifying FHA Streamlines & VA
                                  IRRRLs: <strong>$895</strong>
                                </p>
                                <p>
                                  USDA: <strong>$1095</strong>
                                </p>
                                <p>
                                  Jumbo (excluding VA): <strong>+$100</strong>
                                </p>
                                <p>
                                  2 week closing (super rush fee):{" "}
                                  <strong>+$200</strong>
                                </p>
                                <p>
                                  Simultaneous 1st/2nd Combo:{" "}
                                  <strong>+$200</strong>
                                </p>
                                <p>
                                  Non-QM: <strong>+$200</strong>
                                </p>
                                <p>
                                  LOA Hybrid***** <strong>$1,495</strong>
                                </p>
                              </div>
                              <div className="pricing-block-right">
                                <p>
                                  Conventional, FHA, VA, HELOCs, Stand Alone
                                  Seconds & Reverse Mortgages:{" "}
                                  <strong>$995</strong>
                                </p>
                                <p>
                                  Loans in CT & KY: <strong>+$100</strong>
                                </p>
                                <p>
                                  3 week closing (rush fee):{" "}
                                  <strong>+$100</strong>
                                </p>
                                <p>
                                  Manual Underwrite: +$200 (not including VA
                                  IRRRLs & NCQ FHA Streamlines)
                                </p>
                                <p>
                                  DPA (Down Payment Assistance):{" "}
                                  <strong>+$200</strong>
                                </p>
                                <p>
                                  Renovation or One-Time Close:{" "}
                                  <strong>+$300</strong>
                                </p>
                                <p>
                                  Commercial & Hard Money Loans *:{" "}
                                  <strong>TBD *</strong>
                                </p>
                              </div>
                            </div>
                            <div className="py-4">
                              <p>
                                Pricing to be determined based on scenario- get
                                with SMP Director
                              </p>
                              <p>
                                Fees are only charged if needed. (Ex: a rush fee
                                is not charged if the file closes in 2 weeks and
                                that was not needed, it`s only if it was needed
                                from the submission.)
                              </p>
                              <p>
                                Re-disclosure fee of $100 also applies if at
                                anytime during the process you change lenders
                                (each time) or have to start a new application
                                with the same lender.
                              </p>
                              <p>
                                Mortgage Support understands this is not a
                                guarantee the file will be accepted by a
                                Processor. SMP will reach out if your file is
                                not able to be accepted within 48 hours with
                                alternate solutions.
                              </p>
                            </div>
                            <div className="disclaimer-block">
                              <h6>**DISCLAIMER**</h6>
                              <p className="mb-0">
                                Mortgage Support who already have an established
                                business relationship with SMP prior to
                                01/01/2024 (including but not limited to
                                submitting a file, closing a file, or otherwise
                                engaging in conversations about working with a
                                current SMP Processor after the Broker Agreement
                                was executed), will retain SMP base pricing
                                effective 11/02/2023 [excluding LOs in LO
                                Training Program.])
                              </p>
                            </div>
                            <div className="py-3">
                              <div className="custom-control custom-checkbox custom-checkbox-lg  custom-checkbox-primary mb-3 d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customCheckcolor2"
                                  checked
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customCheckcolor2"
                                >
                                  I read the above note and acknowledge it.
                                </label>
                              </div>
                            </div>
                            <div className="d-flex gap-15 mb-5">
                              <button
                                type="submit"
                                className="btn btn-outline-danger w-md btn-lg px-5"
                              >
                                previous
                              </button>
                              <button
                                type="submit"
                                className="btn btn-primary w-md btn-lg px-5"
                              >
                                Next
                              </button>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/* LendFlow Tab */}
                    <Tab.Pane eventKey="LendFlow">
                      <Card>
                        <Card.Body>
                          <div className="pb-4">
                            <img src="assets/images/get-loan-guid-instructions-1.jpg" />
                          </div>
                          <div className="alert alert-success d-flex align-items-center px-3 py-2 mb-4">
                            <div className="d-flex flex-column">
                              <span>
                                To upload documents, you must add the LendFlow
                                Loan URL.
                              </span>
                            </div>
                          </div>
                          <div className="form-group mb-4">
                            <label htmlFor="formrow-firstname-input">URL</label>
                            <input
                              type="text"
                              className="form-control"
                              id="formrow-firstname-input"
                              value="Paste URL here"
                            />
                          </div>
                          <div className="form-group mb-4">
                            <label htmlFor="formrow-firstname-input">
                              Action required: Share key loan details or notify
                              about LendFlow use
                            </label>
                            <textarea
                              className="form-control"
                              rows={8}
                            ></textarea>
                          </div>
                          <div className="d-flex gap-15 mb-5">
                            <button
                              type="submit"
                              className="btn btn-outline-danger w-md btn-lg px-5"
                            >
                              previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary w-md btn-lg px-5"
                            >
                              Next
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/* Property Tab */}
                    <Tab.Pane eventKey="property">
                      <Card>
                        <Card.Body>
                          <div className="section-sub-heading d-flex justify-content-center mb-3">
                            <h3>Do you have 3.4 file created ?</h3>
                          </div>
                          <div className="d-flex justify-content-center gap-50 mb-5">
                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                              <input
                                type="radio"
                                id="customRadiocolor1"
                                name="customRadiocolor1"
                                className="custom-control-input"
                                checked
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="customRadiocolor1"
                              >
                                <strong>Yes</strong>
                              </label>
                            </div>
                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                              <input
                                type="radio"
                                id="customRadiocolor2"
                                name="customRadiocolor1"
                                className="custom-control-input"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="customRadiocolor2"
                              >
                                <strong>No</strong>
                              </label>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Property Address
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value="Buckeye"
                                  />
                                  <i className="city-icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Property Located in What State ?
                                </label>
                                <select className="form-control">
                                  <option>Arizona</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  City
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value="Buckeye"
                                  />
                                  <i className="city-icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  ZIP Code
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value="85396"
                                  />
                                  <i className="zip-icon"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex gap-15 mb-5">
                            <button
                              type="submit"
                              className="btn btn-outline-danger w-md btn-lg px-5"
                            >
                              previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary w-md btn-lg px-5"
                            >
                              Next
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/* Borrower Tab */}
                    <Tab.Pane eventKey="borrower">
                      <Card>
                        <Card.Body>
                          <div className="section-heading">
                            <h2>Borrower</h2>
                          </div>
                          <div className="section-sub-heading d-flex justify-content-center mb-4">
                            <h3>Primary Applicant</h3>
                          </div>
                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Borrower First Name
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon username_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Borrower Middle Name
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon username_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Borrower Last Name
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon username_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Email
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon email_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Phone
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon phone_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Date Of Birth
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon calender_icon"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="contactmethodbg">
                            <div className="d-flex align-items-center gap-10">
                              <p className="contact_method p-0 m-0">
                                Contact Method :
                              </p>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor1b"
                                  name="customRadiocolor1b"
                                  className="custom-control-input"
                                  checked
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor1b"
                                >
                                  Email
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor2b"
                                  name="customRadiocolor1b"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor2b"
                                >
                                  Phone
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor3b"
                                  name="customRadiocolor1b"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor3b"
                                >
                                  Text
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="section-sub-heading d-flex justify-content-center mb-4 mt-4">
                            <h3>Current Address</h3>
                          </div>

                          <div className="row mb-3">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Street Address
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon streedadr_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  State
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value=""
                                  />
                                  <i className="input_rgticon state_icon"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  City
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon city-icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  ZIP Code
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex gap-15 mb-5">
                            <button
                              type="submit"
                              className="btn btn-outline-danger w-md btn-lg px-5"
                            >
                              previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary w-md btn-lg px-5"
                            >
                              Next
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/*Loan Tab */}
                    <Tab.Pane eventKey="loan">
                      <Card>
                        <Card.Body>
                          <div className="section-heading">
                            <h2>Loan</h2>
                          </div>

                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  LendingPad Loan Number
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Loan Amount
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Loan Type
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Property Type
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Loan Purpose
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Fico
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="contactmethodbg d-flex align-items-center justify-content-between gap-10 mb-4">
                            <div className="d-flex align-items-center">
                              <p className="contact_method p-0 m-0">
                                Occupancy Type ?
                              </p>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor1c"
                                  name="customRadiocolor1c"
                                  className="custom-control-input"
                                  checked
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor1c"
                                >
                                  Primary
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor2c"
                                  name="customRadiocolor1c"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor2c"
                                >
                                  Second
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor3c"
                                  name="customRadiocolor1c"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor3c"
                                >
                                  Investment
                                </label>
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              <p className="contact_method p-0 m-0">
                                Registered with a lender?
                              </p>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor1d"
                                  name="customRadiocolor1d"
                                  className="custom-control-input"
                                  checked
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor1d"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor2d"
                                  name="customRadiocolor1d"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor2d"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Escrow/Impound Type
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Lender
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Mortgage Insurance Type
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Estimated Value or Sales Price
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  LTV
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Compensation Payer Type
                                </label>
                                <select className="form-control">
                                  <option></option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="contactmethodbg d-flex align-items-center justify-content-between gap-10 mb-4">
                            <div className="d-flex align-items-center">
                              <p className="contact_method p-0 m-0">
                                Occupancy Type ?
                              </p>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor1c"
                                  name="customRadiocolor1c"
                                  className="custom-control-input"
                                  checked
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor1c"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor2c"
                                  name="customRadiocolor1c"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor2c"
                                >
                                  No
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor3c"
                                  name="customRadiocolor1c"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor3c"
                                >
                                  Other
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-15 mb-5">
                            <button
                              type="submit"
                              className="btn btn-outline-danger w-md btn-lg px-5"
                            >
                              previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary w-md btn-lg px-5"
                            >
                              Next
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/*info Tab */}
                    <Tab.Pane eventKey="info">
                      <Card>
                        <Card.Body>
                          <div className="section-heading">
                            <h2>Title Company Contact Info</h2>
                          </div>

                          <div className="row">
                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Title Company Name
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon username_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Title Agent's Name
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon username_icon"></i>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Title Agent's Email
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon email_icon"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Title Agent's Phone
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon phone_icon"></i>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-15 mb-5">
                            <button
                              type="submit"
                              className="btn btn-outline-danger w-md btn-lg px-5"
                            >
                              previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary w-md btn-lg px-5"
                            >
                              Next
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>

                    {/*processing Tab */}
                    <Tab.Pane eventKey="processing">
                      <Card>
                        <Card.Body>
                          <div className="section-heading">
                            <h2>Title Company Contact Info</h2>
                          </div>

                          <div className="row">
                            <div className="col-lg-12 col-md-12 mb-4">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Estimated Closing Date
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                  <i className="input_rgticon calender_icon2"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  Estimated Cash To/(From) Borrower on LE
                                  (please be detailed)
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <label htmlFor="formrow-firstname-input">
                                  If Correspondent, what is your par rate? (If
                                  Brokered, N/A)
                                </label>
                                <div className="fld-icon-end">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="formrow-firstname-input"
                                    value=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="contactmethodbg d-flex justify-content-center flex-column align-items-center gap-10 mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <p className="contact_method p-0 m-0">
                                Interest Rate Status :
                              </p>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor1e"
                                  name="customRadiocolor1e"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor1c"
                                >
                                  Float
                                </label>
                              </div>
                              <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                <input
                                  type="radio"
                                  id="customRadiocolor2e"
                                  name="customRadiocolor1e"
                                  className="custom-control-input"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customRadiocolor2e"
                                >
                                  Locked
                                </label>
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="row">
                                <div className="col-lg-6 col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="formrow-firstname-input">
                                      Locked Rate
                                    </label>
                                    <div className="fld-icon-end">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="formrow-firstname-input"
                                        value=""
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="formrow-firstname-input">
                                      Lock Exp Date
                                    </label>
                                    <div className="fld-icon-end">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="formrow-firstname-input"
                                        value=""
                                      />
                                      <i className="input_rgticon calender_icon2"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">Non QM :</p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1f"
                                    name="customRadiocolor1f"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1f"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2f"
                                    name="customRadiocolor1f"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2f"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">
                                Renovation :
                              </p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1g"
                                    name="customRadiocolor1g"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1g"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2g"
                                    name="customRadiocolor1g"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2g"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">
                                Is This Loan Brokered :
                              </p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1h"
                                    name="customRadiocolor1h"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1h"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2h"
                                    name="customRadiocolor1h"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2h"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="section-heading mb-0"></div>

                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">
                                Manual UW :
                              </p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1i"
                                    name="customRadiocolor1i"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1i"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2i"
                                    name="customRadiocolor1i"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2i"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">
                                One-Time Close :
                              </p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1j"
                                    name="customRadiocolor1j"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1j"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2j"
                                    name="customRadiocolor1j"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2j"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">Cash :</p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1k"
                                    name="customRadiocolor1k"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1k"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2k"
                                    name="customRadiocolor1k"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2k"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="section-heading mb-0"></div>

                          <div className="row">
                            <div className="col-lg-8 col-md-8">
                              <p className="contact_method p-0 m-0">
                                Closing Costs to Disclose on LE? :
                              </p>
                              <div className="d-flex flex-column">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1l"
                                    name="customRadiocolor1l"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1l"
                                  >
                                    See Title Fee Sheet Uploaded to
                                    LOS/Lendingpad
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2l"
                                    name="customRadiocolor1l"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2l"
                                  >
                                    Use Lender`s "Smart Fees"
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor3l"
                                    name="customRadiocolor1l"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor3l"
                                  >
                                    I have entered the fees on the Fee Worksheet
                                    in LOS/LendingPad exactly <br /> how I want
                                    them disclosed.
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-4 col-md-4">
                              <p className="contact_method p-0 m-0">
                                Is This Loan Correspondent :
                              </p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1m"
                                    name="customRadiocolor1m"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1m"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2m"
                                    name="customRadiocolor1m"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2m"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="section-heading mb-0"></div>
                          <div className="row mb-4">
                            <div className="col-lg-12 col-md-12">
                              <p className="contact_method p-0 m-0">
                                Waive UW Fee (or Applicable Lender Fee) :
                              </p>
                              <div className="d-flex">
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor1n"
                                    name="customRadiocolor1n"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor1n"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-primary radio-check-btn">
                                  <input
                                    type="radio"
                                    id="customRadiocolor2n"
                                    name="customRadiocolor1n"
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="customRadiocolor2n"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex gap-15 mb-5">
                            <button
                              type="submit"
                              className="btn btn-outline-danger w-md btn-lg px-5"
                            >
                              previous
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary w-md btn-lg px-5"
                            >
                              Submit
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Tab.Pane>
                  </Tab.Content>
                </div>

                <div className="col-sm-3">
                  <div className="profile-details-block">
                    <div className="d-flex justify-content-center flex-column align-items-center">
                      <div className="profile-pic-upload mb-4">
                        <img
                          className="rounded-circle avatar-xl"
                          alt="200x200"
                          src="assets/images/users/avatar-2.jpg"
                          data-holder-rendered="true"
                        />
                      </div>
                      <h5>Kim Kircher (Director)</h5>
                      <div className="email-block">
                        <p className="d-flex align-items-center gap-2">
                          <i className="prof-mail-icon"></i>{" "}
                          kkircher@securedmp.com
                        </p>
                      </div>
                      <p className="d-flex align-items-center gap-2">
                        <i className="prof-phone-icon"></i> 858-952-8133
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </Layout>
  );
};

export default Submitfile;
